export default "__VITE_ASSET__0382e5b4__"